export default function isArray(value) {
  return Array.isArray(value);
}
